import { useCallback, useContext } from 'react';
import { AppErrorContext } from './AppErrorBoundary';
import { AppErrorName } from './AppErrorMap';

const useAppErrorDispatcher = (): {
  dispatch: (errorName: AppErrorName) => void;
  reset: (errorName: AppErrorName) => void;
} => {
  const { dispatch } = useContext(AppErrorContext);

  const dispatchError = useCallback(
    (errorName: AppErrorName) => dispatch({ type: 'error', error: errorName }),
    [dispatch]
  );

  const dispatchReset = useCallback(
    (errorName: AppErrorName) => dispatch({ type: 'reset', error: errorName }),
    [dispatch]
  );

  return { dispatch: dispatchError, reset: dispatchReset };
};

export default useAppErrorDispatcher;
